// Offage reason options for stock receiving (Add Stock and the line splits verification step).
// Kept in alphabetical order so the picker reads predictably — add new reasons in place rather
// than appending to the end.
const OFFAGE_REASON_OPTIONS = [
  'Contaminated',
  'Damaged',
  'Expired',
  'Inventory Count',
  'Missing',
  'Packaging Defect',
  'Short Shipped',
  'Temperature Excursion',
  'Wrong Item',
];

export default OFFAGE_REASON_OPTIONS;
